export default {
  messages: {
    required: 'This field is required.',
    email: 'This field must be a valid email.'
  },
  modules: {
    dashboard: 'Dashboard',
    schedule: 'Agenda',
    reports: 'Relatórios'
  },
  general: {
    filters: 'Filtros',
    load_more: 'Carregar mais',
    save: 'Salvar',
    send: 'Enviar',
    save_changes: 'Salvar alterações',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    confirm_schedule: 'Confirmar/Recusar Agendamento',
    refuse: 'Recusar',
    edit: 'Editar',
    delete: 'Excluir',
    ok: 'Ok',
    all: 'Todos',
    yes: 'Sim',
    no: 'Não',
    active: 'Ativo',
    next: 'Avançar',
    inactive: 'Inativo',
    enable: 'Ativar',
    disable: 'Desativar',
    name: 'Nome',
    username: 'Nome de usuário',
    email: 'E-mail',
    phone: 'Telefone',
    role: 'Tipo',
    password: 'Senha',
    retype_password: 'Confirmar senha',
    search_placeholder: 'Busque por palavra-chave',
    search_empty: 'Desculpe, nenhum resultado foi encontrado.',
    type_here: 'Digite aqui',
    address: 'Endereço',
    start: 'Inicio',
    end: 'Fim',
    street: 'Rua',
    zip: 'Cep',
    neighbourhood: 'Bairro',
    number: 'Nº',
    register: 'Cadastrar',
    complement: 'Complemento',
    state: 'Estado',
    city: 'Cidade',
    reference: 'Ponto de referência',
    uf: 'UF',
    period: 'Período',
    another_partner: 'Outro parceiro',
    days_before: 'Dias de antecedência',
    category_not_selected: 'Você deve escolher uma categoria',
    times: {
      morning: 'Manhã',
      afternoon: 'Tarde',
      night: 'Noite',
      morningAfternoon: 'Manhã e Tarde',
      afternoonNight: 'Tarde e Noite',
      full: 'Dia inteiro'
    },
    registered: 'Cadastrado em',
    no_data: 'There are no results for your search criteria'
  },
  login: {
    submit: 'Login',
    forgot_password: 'Esqueceu sua senha?',
    recover_password: 'Recuperar Senha',
    define_password: 'Definir Senha',
    back_to_login: 'Voltar para o login'
  },
  status: {
    scheduled: 'Agendado',
    canceled: 'Cancelado',
    notCompleted: 'Nāo realizada',
    completed: 'Realizada',
    refused: 'Recusado',
    waitingManagerReview: 'Aguardando gerente',
    waitingPartnerReview: 'Aguardando parceiro',
    waitingApproval: 'Pendente',
    completedWaitingPartnerReview: 'Realizada',
    notCompletedWaitingPartnerReview: 'Não realizada',
    waitingYourEvaluation: 'Aguardando sua avaliação',
    confirmed: 'Confirmado'
  },
  details: {
    partner: 'Parceiro',
    brand: 'Marca',
    focus: 'Foco',
    store: 'Loja',
    stores: 'Lojas',
    status: 'Status',
    type: 'Tipo',
    type_training: 'Tipo de treinamento',
    category: 'Categoria',
    date: 'Data',
    time: 'Horário',
    available_periods: 'Períodos Disponíveis',
    address: 'ENDEREÇO DO TREINAMENTO',
    participants_list: 'Lista de participantes',
    enter_the_name_of_participants_here:
      'Insira os nomes dos participantes aqui',
    new_schedule_request: 'Nova solicitação de agendamento:',
    new_training_request: 'Você recebeu uma nova solicitação de agendamento',
    training_modified: 'Um agendamento foi modificado',
    activity_completed: 'Uma atividade foi concluída',
    modifications_on: 'Modificações no',
    feedback: 'Dar feedback',
    admin_feedback: 'FEEDBACK',
    manager_feedback: 'FEEDBACK DA LOJA',
    partner_feedback: 'FEEDBACK DO PARCEIRO',
    manager_feedback_empty: 'O GERENTE DA LOJA AINDA NÃO DEU SEU FEEDBACK',
    partner_feedback_empty: 'O PARCEIRO AINDA NÃO DEU SEU FEEDBACK',
    cancel_action: 'Cancelar ação',
    edit_action: 'Editar ação',
    cancel_training: 'Cancelar treinamento',
    edit_training: 'Editar treinamento',
    cancel_fixedba: 'Cancelar BA fixa',
    edit_fixedba: 'Editar BA fixa',
    of_mini_event: 'do mini evento',
    of_special_animation: 'da animaçāo especial',
    promoter_type: 'tipo de promotor',
    street: 'Rua',
    sign_number: 'Nº',
    cep: 'Cep',
    complement: 'Complemento',
    neighbourhood: 'Bairro',
    city: 'Cidade',
    city_uf: 'CIDADE / UF',
    reference: 'Ponto de Referência',
    materials: 'MATERIAIS',
    details_action: 'DETALHES DA AÇÃO',
    details_training: 'DETALHES DO TREINAMENTO',
    details_fixedba: 'DETALHES DA BA FIXA',
    details_store: 'Detalhes da loja',
    observation: 'OBSERVAÇÃO',
    justification: 'MOTIVO DA RECUSA',
    start_date: 'Data de início',
    end_date: 'Data de fim',
    week_day: 'Dia da Semana',
    promoter_name: 'Nome do promotor',
    coach_name: 'Nome do treinador'
  },
  notifications: {
    times: {
      days_before: 'dias atrás',
      day_before: 'dia atrás',
      hours_before: 'horas atrás',
      hour_before: 'hora atrás',
      minutes_before: 'minutos atrás',
      minute_before: 'minuto atrás',
      few_seconds_before: 'Alguns segundos atrás'
    },
    empty_notifications: 'Não há notificações.'
  },
  shared: {
    action: 'Açāo',
    actions: 'Ações',
    training: 'Treinamento',
    trainings: 'Treinamentos',
    fixedba: 'BA fixa',
    fixedbas: 'BA fixa',
    action_types: {
      simpleAnimation: 'Animação simples',
      specialAnimation: 'Animação especial',
      fixedba: 'BA fixa',
      miniEvent: 'Mini evento'
    },
    training_types: {
      internal: 'Interno',
      external: 'Externo'
    },
    type_of_training: 'Tipo de treinamento'
  },
  header: {
    logout: 'Sair',
    new_schedule: 'Novo agendamento'
  },
  admin: {
    enable_partner: 'Ativar parceiro',
    disable_partner: 'Desativar parceiro',
    enable_store: 'Ativar loja',
    disable_store: 'Desativar loja'
  },
  dashboard: {
    title_collaborator: 'Agendamentos da(s) minha(s) loja(s)',
    title_manager: 'Agendamentos da(s) minha(s) loja(s)',
    title_partner: 'Meus agendamentos',
    title_admin: 'Agendamentos',
    title_root: 'Agendamentos',
    title_fixedba: 'BA fixas',
    see_details: 'Ver detalhes',
    approve_schedule: 'Aprovar treinamento',
    create_schedule: 'Realizar agendamento',
    cancel_schedule: 'Cancelar agendamento',
    finish_and_feedback: 'Concluir e dar feedback',
    date: 'Data',
    enable_day: 'Ativar dia',
    disable_day: 'Desativar dia'
  },
  partners: {
    partners: 'Parceiros',
    partner: 'Parceiro',
    brands: 'Marca(s)',
    brands2: 'Marcas',
    brand: 'Marca',
    modal_brands: 'Marcas',
    general_information: 'INFORMAÇÕES GERAIS',
    action: 'Açāo',
    store: 'Loja',
    code: 'Código',
    store_code: 'Código da loja',
    representative: 'Representante',
    representatives: 'Representantes',
    name_of: 'Nome do',
    name_of_fem: 'Nome da',
    email_of: 'Email do',
    name_of_brand: 'Nome da marca',
    categories: 'Categoria(s)',
    select_category: 'Selecione uma ou mais categorias',
    detail_partner: 'Detalhes do Parceiro',
    edit_partner: 'Editar parceiro',
    add: 'Adicionar'
  },
  category: {
    categories: 'Categorias',
    category: 'Categoria'
  },
  new_schedule: {
    type_title: 'Novo agendamento',
    schedule_action_title: 'Agendar ação',
    schedule_training_title: 'Agendar treinamento',
    edit_action_title: 'Editar ação',
    edit_training_title: 'Editar treinamento',
    type_description:
      'Realize de forma fácil e intuitiva o agendamento de sua ação ou treinamento preenchendo este formulário.',
    action_description:
      'Preencha o formulário abaixo para realizar o agendamento de sua ação automaticamente.',
    training_description:
      'Preencha o formulário abaixo para solicitar o agendamento de seu treinamento. Você será informado sobre a aprovação dela pelo gerente da loja.',
    submit_schedule: 'Efetuar agendamento',
    edit_schedule: 'Alterar agendamento',
    action_type: 'Tipo de ação',
    training_type: 'Tipo de treinamento',
    training_local: 'Local de treinamento',
    materials_list: 'Materiais',
    promoter_type: 'Tipo de promotor',
    selects: {
      select_partner: 'Selecione o parceiro',
      select_the_action_type: 'Selecione o tipo de ação',
      select_brands: 'Selecione a(s) marca(s)',
      select_city: 'Selecione a cidade',
      select_store: 'Selecione a loja',
      select_category: 'Selecione a categoria',
      select_the_promoter_type: 'Selecione o tipo de promotor',
      select_date: 'Selecione a data'
    },
    observation: 'Observação',
    promoter_name: 'Nome do promotor',
    coach_name: 'Nome do treinador',
    observationExternalTraining:
      'Favor especificar o horário de chegada e saída do treinador em loja, além de outras observações necessárias',
    observationInternalTraining:
      'Especifique as turmas e seus horários (Exemplo 1: Turma única – 10h as 18h. Exemplo 2: Turma manhã - 10h as 13h. Turma tarde - 14h as 17h):',
    type_here: 'Digite aqui',
    mini_event_materials: 'Materiais do mini evento',
    specialAction_materials: 'Materiais da animação especial',
    materials: {
      gifts: 'Brindes',
      cocktail: 'Coquetel',
      pdv_material: 'Material PDV'
    },
    material_size: 'Tamanho do Material PDV',
    validity: 'Vigência',
    obligation_cocktail:
      'A opção "Coquetel" é obrigatória. O parceiro deve levar coquetel para o mini evento.',
    obligation_pdv:
      'A opção "Material PDV" é obrigatória. O parceiro deve levar o material PDV para a animação especial.',
    weekDays: 'Dias da semana',
    internal: 'Interno',
    external: 'Externo',
    missing_field_start: 'O campo ',
    missing_field_end: ' deve ser preenchido',
    missing_fields_start: 'Os campos ',
    missing_fields_end: ' devem ser preenchidos'
  },
  promoter_types: {
    freelancer: 'Freelancer',
    specialist: 'Especialista',
    type_promoter: 'Tipo de promotor',
    promoter: 'Promotor'
  },
  schedule: {
    title: 'Agenda',
    month: 'Mês',
    week: 'Semana',
    simpleAnimation: 'Animação simples',
    specialAnimation: 'Animação especial',
    fixedba: 'BA Fixa',
    miniEvent: 'Mini evento',
    internal: 'Treinamento interno',
    external: 'Treinamento externo'
  },
  reports: {
    export: 'Exportar',
    last: 'Últimos',
    days: 'dias',
    custom: 'Personalizar',
    all_days: 'Todo período',
    all_stores: 'Todas as lojas',
    all_brands: 'Todas as marcas',
    all_states: 'Todos os estados',
    action_scheduled: 'Ações agendadas',
    action_completed: 'Ações realizadas',
    action_notCompleted: 'Ações não realizadas',
    action_canceled: 'Ações canceladas',
    training_scheduled: 'Treinamentos agendados',
    training_completed: 'Treinamentos realizados',
    training_notCompleted: 'Treinamentos não realizados',
    training_canceled: 'Treinamentos cancelados',
    title_type_action: 'Tipos de ação no período',
    title_category_action: 'Categorias no período',
    title_brand_action: 'Marcas no período',
    title_store_action: 'Agendamentos por loja no período',
    title_state_action: 'Agendamentos por estado no período',
    title_type_training: 'Tipos de treinamento no período',
    title_category_training: 'Categorias no período',
    title_brand_training: 'Marcas no período',
    title_store_training: 'Agendamentos por loja no período',
    title_state_training: 'Agendamentos por estado no período'
  },
  error: {
    0: 'Oops, something went wrong. Please try again.',
    1001: 'E-mail não encontrado ou usuário está inativo',
    1002: 'A senha digitada é inválida',
    1003: 'O token é inválido',
    1004: 'O token expirou',
    1005: 'Captcha inválido',
    1006: 'Senha inválida. Ela deve conter ao menos 8 caracteres, 1 letra minúscula, 1 letra maiúscula, 1 número e 1 caracter especial',
    1007: 'Senha expirada',
    1008: 'Essa senha já foi utilizada anteriormente',
    password_mismatch: 'As senhas devem coincindir',
    email_invalid: 'O campo deve conter um e-mail válido',
    error_generic: 'Ocorreu uma falha no sistema. Tente novamente mais tarde.',
    error_cancel_schedule:
      'Erro ao cancelar agendamento. Tente novamente mais tarde.',
    error_cancel_all_schedules:
      'Erro ao cancelar todos os agendamentos. Tente novamente mais tarde.',
    error_create_draft: 'Erro ao criar o draft',
    error_update_draft: 'Erro ao atualizar o draft',
    error_create_schedule: 'Erro ao realizar o agendamento',
    error_edit_schedule: 'Erro ao editar o agendamento',
    error_available_dates: 'Erro ao requisitar as datas disponíveis',
    error_invalid_date: 'A data selecionada não está mais disponível',
    error_invalid_date_fixedba: 'A data de início deve ser menor que a de fim',
    error_invalid_period: 'A período selecionado não está mais disponível',
    error_refuse_schedule: 'Erro ao recusar o agendamento'
  },
  success: {
    update_password: 'Senha atualizada',
    recover_password: 'Um email será enviado com as informações',
    edit_rules: 'As regras foram atualizadas',
    add_partner: 'Parceiro adicionado com sucesso',
    edit_partner: 'Parceiro editado com sucesso',
    add_store: 'Loja adicionada com sucesso',
    edit_store: 'Loja editada com sucesso',
    add_category: 'Categoria adicionada com sucesso',
    edit_category: 'Categoria editada com sucesso'
  },
  datepicker: {
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    days: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ],
    daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  }
};
